import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessButtons' })(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'var(--ebl-s2)',
  },
  button: {
    marginLeft: 0,
    marginRight: 0,
  },
}));
